/**
 * formatNumber - removes the decimal if it is a whole size. 10.0 => 10, 10.5 => 10.5, xs => xs
 * @param numberString: string
 * @returns string
 */
function formatNumber(numberString) {
  // convert "10.0" to 10, convert "10.5" to 10.5
  const number = Number(numberString);

  // return the size if it is not a number (xs -> xs)
  if (Number.isNaN(number)) return numberString;

  return number.toString();
}

export const getSizeValueFromPresentation = (sizePresentation, sizeOptions) => {
  if (!sizePresentation || !sizeOptions) {
    return '';
  }

  const size = sizeOptions.find(
    (sizeOption) => sizeOption.presentation === formatNumber(sizePresentation.toLowerCase()),
  );

  return size ? size.value?.toString() : '';
};
